import React from 'react';
import { Profile } from '@/types/auth';
import { ProfileHeaderWidget } from './ProfileHeaderWidget';
import { BioWidget } from './BioWidget';
import { StatsWidget } from './StatsWidget';
import { SocialLinksWidget } from './SocialLinksWidget';
import { BannerWidget } from './BannerWidget';
import { GalleryWidget } from './GalleryWidget';
import { ContactWidget } from './ContactWidget';
import { AchievementsWidget } from './AchievementsWidget';

interface BentoWidgetProps {
  widgetId: string;
  profile: Profile;
  isEditMode: boolean;
}

export const BentoWidget: React.FC<BentoWidgetProps> = ({
  widgetId,
  profile,
  isEditMode,
}) => {
  const renderWidget = () => {
    switch (widgetId) {
      case 'profile-header':
        return <ProfileHeaderWidget profile={profile} />;
      case 'bio':
        return <BioWidget profile={profile} />;
      case 'stats':
        return <StatsWidget profile={profile} />;
      case 'social-links':
        return <SocialLinksWidget profile={profile} />;
      case 'banner':
        return <BannerWidget profile={profile} />;
      case 'gallery':
        return <GalleryWidget profile={profile} />;
      case 'contact':
        return <ContactWidget profile={profile} />;
      case 'achievements':
        return <AchievementsWidget profile={profile} />;
      default:
        return (
          <div className="flex items-center justify-center h-full text-muted-foreground">
            <p>Unknown widget: {widgetId}</p>
          </div>
        );
    }
  };

  const shouldRemovePadding = widgetId === 'profile-header' || widgetId === 'banner';

  return (
    <div className={`h-full w-full flex flex-col relative ${shouldRemovePadding ? '' : 'p-3 md:p-4'}`} style={{ zIndex: 1 }}>
      {renderWidget()}
    </div>
  );
};